module.exports = __webpack_public_path__ + "img/tom_collins.ae6d8d96.jpg";